var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9.97198C9.65685 9.97198 11 8.6234 11 6.95984C11 5.29628 9.65685 3.94769 8 3.94769C6.34315 3.94769 5 5.29628 5 6.95984C5 8.6234 6.34315 9.97198 8 9.97198ZM8 8.96794C6.89543 8.96794 6 8.06888 6 6.95984C6 5.8508 6.89543 4.95174 8 4.95174C9.10457 4.95174 10 5.8508 10 6.95984C10 8.06888 9.10457 8.96794 8 8.96794Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8.96794C16 13.4041 12.4183 17.0003 8 17.0003C3.58172 17.0003 0 13.4041 0 8.96794C0 4.53177 3.58172 0.935547 8 0.935547C12.4183 0.935547 16 4.53177 16 8.96794ZM3.67343 14.4934C4.86425 15.4347 6.36681 15.9963 8 15.9963C9.63319 15.9963 11.1357 15.4347 12.3266 14.4934C11.4414 12.9472 9.79518 11.9805 8 11.9805C6.20482 11.9805 4.55858 12.9472 3.67343 14.4934ZM2.91977 13.8032C1.72992 12.5433 1 10.8412 1 8.96794C1 5.08629 4.13401 1.9396 8 1.9396C11.866 1.9396 15 5.08629 15 8.96794C15 10.8412 14.2701 12.5433 13.0802 13.8032C11.9944 12.0581 10.0805 10.9764 8 10.9764C5.91949 10.9764 4.00565 12.0581 2.91977 13.8032Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.a11896ba3bebf60f525d31b9c46c6f71.svg";
export { ForwardRef as ReactComponent };